import React, { useState, useEffect } from 'react';
import logo from '../assets/images/hjlogo.png';

const isWebView = () => {
    if (typeof navigator === 'undefined') return false;
    const userAgent = navigator.userAgent.toLowerCase();
    const rules = [
        'linkedin',
        'fbav',
        'instagram',
        'twitter',
        'pinterest',
        'gsa', 
        '; wv' 
    ];
    // iOS check: if it's an iOS device but not safari, it's a webview
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    const isSafari = /safari/.test(userAgent);

    if (isIOS && !isSafari) {
        return true;
    }

    return rules.some(rule => userAgent.includes(rule));
};

const WebViewDetector = ({ children }) => {
    const [showWarning, setShowWarning] = useState(false);

    useEffect(() => {
        if (isWebView()) {
            setShowWarning(true);
        }
    }, []);

    if (showWarning) {
        return (
            <div style={{
                padding: '2rem',
                textAlign: 'center',
                backgroundColor: '#f8f9fa',
                color: '#212529',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                fontFamily: 'sans-serif'
            }}>
                <img src={logo} alt="Logo" style={{ width: '100px', marginBottom: '2rem' }} />
                <h1 style={{ fontSize: '1.75rem', marginBottom: '1rem', color: '#dc3545' }}>Access Restricted</h1>
                <p style={{ fontSize: '1rem', lineHeight: '1.6', maxWidth: '500px', marginBottom: '2rem' }}>
                    For security reasons, you cannot sign in from an in-app browser. Please open this page in your main browser (like Chrome, Safari, or Firefox) to continue.
                </p>
                <p style={{
                    fontSize: '0.9rem',
                    color: '#6c757d',
                    border: '1px solid #dee2e6',
                    padding: '1rem',
                    borderRadius: '8px',
                    backgroundColor: '#fff'
                }}>
                    <strong>How to open in browser:</strong><br />
                    Look for a menu (usually three dots ••• or a share icon) and select "Open in Browser" or "Open in Safari/Chrome".
                </p>
            </div>
        );
    }

    return children;
};

export default WebViewDetector; 